import { Descriptions, Radio } from 'antd';
import * as React from 'react';
import { IOrderInfo } from 'src/entity/OrderEntity';
import I18N from 'src/services/I18NService';
import { RadioChangeEvent } from 'antd/lib/radio';

interface IInvoiceInfo {
  /** 主键 */
  id: string;
  receiver_name?: string;
  receiver_mobile?: string;
  receiver_address?: string;
  receiver_structure_address?: string;
  /** 普通发票 10 */
  invoice_type?: number;
  /** 发票状态 */
  issue_status: 'NOT_YET_ISSUED' | 'HAVE_BEEN_ISSUED';
  /** 个人抬头 10, 单位抬头  20 */
  rise_type?: number;

  personal_name?: string;

  /** 单位名称 */
  unit_name?: string;
  /** 纳税人识别号 */
  taxpayer_identification_number?: string;
  // ... 省略了其他参数

  express_number?: string;
  logistics_company?: string;
}

interface IInvoiceInfoProps {
  /** 订单明细 */
  orderInfo: IOrderInfo;

  invoiceInfo: IInvoiceInfo;

  address: string;

  isAgent: boolean;

  issueStatue: boolean;

  disable: boolean;

  onChange(value: boolean): void;
}

class InvoiceInfo extends React.Component<IInvoiceInfoProps> {
  private getTitleTypeStr(type?: number) {
    if (type === 10) {
      return '个人';
    } else if (type === 20) {
      return '单位';
    }
    return '';
  }

  onChange = async (event: RadioChangeEvent) => {
    this.props.onChange(!!event.target.value);
  };

  render() {
    const { orderInfo, invoiceInfo, address, issueStatue, disable } = this.props;

    return (
      <div className="div-row">
        <div className="div-col-3 text-align-right">{'发票信息'}</div>
        <div className="div-col-15 order_info">
          <Descriptions title="发票详情" bordered={false}>
            <Descriptions.Item label="发票类型">{invoiceInfo.invoice_type === 10 ? '普通发票' : ''}</Descriptions.Item>
            <Descriptions.Item label="发票抬头">{this.getTitleTypeStr(invoiceInfo.rise_type)}</Descriptions.Item>
            {invoiceInfo.rise_type === 10 && <Descriptions.Item label="发票签名">{invoiceInfo.personal_name}</Descriptions.Item>}
            {invoiceInfo.rise_type === 20 && (
              <React.Fragment>
                <Descriptions.Item label="单位名称">{invoiceInfo.unit_name}</Descriptions.Item>
                <Descriptions.Item label="纳税人识别号">{invoiceInfo.taxpayer_identification_number}</Descriptions.Item>
              </React.Fragment>
            )}
            <Descriptions.Item label="收件人">{orderInfo.receiver_name}</Descriptions.Item>
            <Descriptions.Item label="手机号">{orderInfo.receiver_mobile}</Descriptions.Item>
            <Descriptions.Item label="收件地址">
              {address}, {orderInfo.receiver_address}
            </Descriptions.Item>
            <Descriptions.Item label={I18N.get('order_invoice_has_issued')}>
              <Radio.Group value={issueStatue} disabled={disable} onChange={this.onChange}>
                <Radio value={true}>{I18N.get('common_yes', false)}</Radio>
                <Radio value={false}>{I18N.get('common_no', false)}</Radio>
              </Radio.Group>
            </Descriptions.Item>
          </Descriptions>
        </div>
      </div>
    );
  }
}

export default InvoiceInfo;



// WEBPACK FOOTER //
// ./src/components/views/Order/components/InvoiceInfo.tsx